import './fontStyle.css';
import webSocketsMiddleware from '@/vuexDatastore/webSocketsMiddleware';
import vuetify from './plugins/vuetify';
import Vue from 'vue';
import App from './App.vue';
import store from './vuexDatastore/store';
import VueI18n from 'vue-i18n'
import i18n from './i18n'
import router from './router'
// @ts-ignore
import dfLocaleMapping from './assets/dfLocaleMapping.json'
// @ts-ignore
import initEventPageLMTWidget from './assets/lmtUtility.js'
import get = Reflect.get;
// import 'moment/locale/fr';
// import 'moment/locale/es';
import moment from 'moment'
// @ts-ignore


Vue.prototype.moment = moment;
window.moment = moment;
declare global {
  interface Window {
    SelectedLanguage: string;
  }
}
declare global {
  interface Window {
    SelectedTimeLocalisation: string;
  }
}
declare global {
  interface Window {
    activeListCounter: number;
  }
}
declare global {
  interface Window {
    triggeredHash: boolean;
  }
}

// @ts-ignore
window.uuidv4 = function() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}
// window.uuidv4 = function() {
//   // @ts-ignore
//   return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
//     (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
//   );
// }
window.triggeredHash = false;
window.activeListCounter = 0;

const getUrlParameter = function getUrlParameter(sParam: string) {
  let sPageURL = window.location.search.substring(1),
    sURLVariables = sPageURL.split('&'),
    sParameterName,
    i;

  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split('=');

    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
    }
  }
};


let localisationContext = getUrlParameter('LocalisationContext');
let languageParam: any = getUrlParameter('Language');
let brandParam = getUrlParameter('Brand');
let currencyParam = getUrlParameter('Currency');
let tokenParam = getUrlParameter('Token');
let languageCode = 'en';
let countryCode = 'us';
let resolvedLocaleObject: any;

// @ts-ignore
window.dfLocaleMapping = dfLocaleMapping;
if (typeof localisationContext === 'string') {
  resolvedLocaleObject = dfLocaleMapping.find((element: any) => {
    return element.locale === localisationContext
  })
} else {
  resolvedLocaleObject = 'none'
}

if (typeof resolvedLocaleObject === 'undefined' || resolvedLocaleObject === 'none') {
  window.SelectedLanguage = 'en-GB'
  window.SelectedTimeLocalisation = 'en-GB'
} else {
  window.SelectedLanguage = resolvedLocaleObject?.four_letter_locale;
  window.SelectedTimeLocalisation = resolvedLocaleObject?.four_letter_locale;
}
if (typeof languageParam !== 'undefined') {
  try {
    // @ts-ignore
    Intl.getCanonicalLocales(languageParam);
    window.SelectedLanguage = languageParam;
    window.SelectedTimeLocalisation = languageParam;
  } catch (e) {
    window.SelectedLanguage = "en-GB";
    window.SelectedTimeLocalisation = "en-GB";
  }

}
i18n.locale = window.SelectedLanguage;
////

// moment.locale(countryCode)
// Vue.prototype.moment = moment;
// window.moment = moment;
// Vue.config.productionTip = false;
// webSocketsMiddleware.boostrapConnection();
// new Vue({
//   store,
//   vuetify,
//   i18n,
//   router,
//   render: (h) => h(App)
// }).$mount('#app');


Vue.prototype.moment = moment;
// window.moment = moment;
if (/Android|iPhone|iPad|iPod/i.test(navigator.userAgent)) {
  store.dispatch('getStreamUrls', 'Mobile');
  setInterval(function () {
    store.dispatch('getStreamUrls', 'Mobile');
  }, 6000000)
} else {
  store.dispatch('getStreamUrls', 'Desktop');
  setInterval(function () {
    store.dispatch('getStreamUrls', 'Desktop');
  }, 6000000)
}
// @ts-ignore
Date.prototype.toIsoStringLocale = function() {
  let tzo = -this.getTimezoneOffset(),
    dif = tzo >= 0 ? '+' : '-',
    pad = function(num:any) {
      let norm = Math.floor(Math.abs(num));
      return (norm < 10 ? '0' : '') + norm;
    };
  return this.getFullYear() +
    '-' + pad(this.getMonth() + 1) +
    '-' + pad(this.getDate()) +
    'T' + pad(this.getHours()) +
    ':' + pad(this.getMinutes()) +
    ':' + pad(this.getSeconds()) +
    dif + pad(tzo / 60) +
    ':' + pad(tzo % 60);
}

Vue.filter('removeDiacriticsFromUppercase', function (str: string) {
  return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "")

});

Vue.filter('numberWithCommas', function (number:any ) {
  return (new Intl.NumberFormat('en-GB', {minimumFractionDigits:2, maximumFractionDigits:2}).format(number) !== 'NaN'?new Intl.NumberFormat('en-GB', {minimumFractionDigits:2, maximumFractionDigits:2}).format(number):'');
});

Vue.filter('numberWithCommasNoDecimals', function (number:any ) {
  return (new Intl.NumberFormat('en-GB', {minimumFractionDigits:0, maximumFractionDigits:0}).format(number) !== 'NaN'?new Intl.NumberFormat('en-GB', {minimumFractionDigits:0, maximumFractionDigits:0}).format(number):'');
});

Vue.filter('numberWithCommasAndCurrency', function (number:any ,currency:any) {
  let numberToReturn = '';
  let formattedNumberInstance =new Intl.NumberFormat('en-GB', {minimumFractionDigits:2, maximumFractionDigits:2}).format(Math.abs(number));
  numberToReturn = (formattedNumberInstance !== 'NaN') ? formattedNumberInstance : '';
  return (numberToReturn !== '' ? (Number(number)<0 && numberToReturn!='0.00' ? '-' + currency + numberToReturn : currency + numberToReturn) : '');
});

Vue.filter('fillNumberWithZeroes', function (numberString:any) {
  let tempVal = numberString;
  if (typeof  numberString === 'number') {
    tempVal = numberString.toString()
  }
  let integerPart = tempVal.split('.')[0];
  let decimalPart = tempVal.split('.')[1];
  if (decimalPart) {
    if (decimalPart.length === 1) {
      return tempVal + '0'
    } else if (decimalPart.length === 0) {
      return integerPart + '.00'
    }
    else if (decimalPart.length === 2) {
      return tempVal
    } else {
      return Number(`${integerPart}.${decimalPart}`).toFixed(2).toString()
    }
  } else {
    return integerPart + '.00'
  }
});

Vue.filter('capitalise', function (value:any) {
  if (!value) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
});

//LMT widget


initEventPageLMTWidget.initEventPageLMTWidget(window.SelectedLanguage);
// @ts-ignore
//store.commit('setMinimumLiabilty', resolvedLocaleObject? minimumLiabilitiesMap[resolvedLocaleObject.default_currency] : 1)

Vue.config.productionTip = false;
const VueInstance = new Vue({
  store,
  vuetify,
  i18n,
  // router,
  render: (h) => h(App)
}).$mount('#app');

webSocketsMiddleware.boostrapConnection(VueInstance, {
  localisationContext: localisationContext,
  brandParam: (typeof brandParam !== 'undefined' ? brandParam : null),
  currencyParam: (typeof currencyParam !== 'undefined' ? currencyParam : null),
  languageParam: (typeof languageParam !== 'undefined' ? languageParam : null),
  tokenParam: (typeof tokenParam !== 'undefined' ? tokenParam : null)
});

